<div class="dx-search" *ngIf="!es.isClosed">
    <input class="t-field t-field-pad dx-search-input" type="text" autocomplete="off" [(ngModel)]="query" [placeholder]="placeholder" (keydown.enter)="addFirst(); $event.preventDefault()" />
    <ul class="dx-search-results" *ngIf="results.length">
        <li *ngFor="let r of results" (mousedown)="add(r[2])">{{r[2]}}</li>
    </ul>
</div>
